module.exports = __webpack_public_path__ + "static/media/bank-of-baroda.cc852121.png";